import { Tutorial } from '../../../entities'

export const updateMultipleTutorial = {
  async updateMultipleTutorial(_: any, { patches }, context: ResolverContext) {
    const { tx, domain, user } = context.state

    let results = []
    const _createRecords = patches.filter((patch: any) => patch.cuFlag.toUpperCase() === '+')
    const _updateRecords = patches.filter((patch: any) => patch.cuFlag.toUpperCase() === 'M')
    const tutorialRepo = tx.getRepository(Tutorial)

    if (_createRecords.length > 0) {
      for (let i = 0; i < _createRecords.length; i++) {
        const newRecord = _createRecords[i]

        const result = await tutorialRepo.save({
          ...newRecord,
          domain,
          creator: user,
          updater: user
        })

        results.push({ ...result, cuFlag: '+' })
      }
    }

    if (_updateRecords.length > 0) {
      for (let i = 0; i < _updateRecords.length; i++) {
        const newRecord = _updateRecords[i]
        const tutorial = await tutorialRepo.findOneBy({ id: newRecord.id })

        const result = await tutorialRepo.save({
          ...tutorial,
          ...newRecord,
          updater: user
        })

        results.push({ ...result, cuFlag: 'M' })
      }
    }

    return results
  }
}
